import { Spinner } from 'react-bootstrap';
export default function LoaderBackdrop() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        zIndex: 984999,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0 , 0, 0, 0.15)'
      }}
    >
      <Spinner animation="border" variant="primary" style={{ height: '5rem', width: '5rem' }} />
    </div>
  );
}
